module.exports = __webpack_public_path__ + "img/blog7.68d5c430.jpg";